import { Button, Grid } from "@material-ui/core";
import CircularLoader from "../../../../../components/loading/circularLoader";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { printReceivableAccountsPDF } from "../../../../../repositories/qerpapi/erp/relatorio/ContasReceberRepository";
import { b64toBlob } from "../../../../../utils/file64toBlob";
import { notify } from "../../../../../utils/notify";
import { periods } from "../../../constants";
import {
  groupBy,
  receiptDates,
  sortBy,
  sortDirections,
} from "../../ContasReceberConstants";
import { useContasReceberService } from "../../context/ContasReceberContext";
import ExportButton from "../ExportButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const {
    cachedPeriod: period,
    filters,
    cachedCompanies,
    cachedMovementData,
    cachedSituations,
    quickSituations,
  } = useContasReceberService();
  const { queryParams } = useContext(QueryParamsContext);

  const handlePrintPDF = async () => {
    const filtersDescriptions = {
      period: {
        label: "Período",
        formatedValue: (searchPeriod) => {
          const objEntries = Object.entries(periods);
          const [key] = objEntries.find(([_, value]) => value === searchPeriod);
          return key;
        },
      },
      startDate: {
        label: "Data inicial",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },
      endDate: {
        label: "Data final",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },

      multicompany: {
        label: "Empresa",
        formatedValue: (company) => {
          const objEntries = Object.entries(cachedCompanies);
          const companies = objEntries.find(([_, value]) => value === company);
          return companies[0] ?? queryParams?.nomeempresa;
        },
      },

      group: {
        label: "Agrupamento",
        formatedValue: (group) => {
          const objEntries = Object.entries(groupBy);
          const [key] = objEntries.find(([_, value]) => value === group);
          return key;
        },
      },
      sort: {
        label: "Ordenação",
        formatedValue: (sort) => {
          const sortDirection =
            filters.sortDirection === sortDirections.asc
              ? `Crescente`
              : "Decrescente";
          const objEntries = Object.entries(sortBy);
          const [key] = objEntries.find(([_, value]) => value === sort);
          return `${key} ${sortDirection}`;
        },
      },
      dateFilter: {
        label: "Data de",
        formatedValue: (dateType) => {
          const objEntries = Object.entries(receiptDates);
          const [key] = objEntries.find(([_, value]) => value === dateType);
          return key;
        },
      },
      quickStatus: {
        label: "Situações Rápidas",
        formatedValue: (_) => {
          const status = quickSituations
            .filter((situation) => filters.quickStatus?.includes(situation.id))
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
      status: {
        label: "Situações",
        formatedValue: (_) => {
          const status = cachedSituations
            .filter((situation) => filters.status?.includes(situation.id))
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
    };

    setPrintLoading(true);

    const getGroupDescription = (group) => {
      if (group === "Sem Agrupamento") return group;

      const objEntries = Object.entries(groupBy);
      const [key] = objEntries.find(([_, value]) => value === group);
      return key;
    };

    const pdfBody = {
      title: "Relatório de Contas a Receber",
      type: "DETALHADO",
      group: getGroupDescription(cachedMovementData[0].group?.type),
      companyName: queryParams?.nomeempresa,
      companyFantasy: queryParams?.apelido,
      headerLogo: queryParams?.imagebase64,
      footerLogo: queryParams?.imagebase64,
      login: queryParams?.usuario_nome,
      filter: Object.entries(filters)
        .filter(([key, _]) => !!filtersDescriptions[key])
        .map(([key, value]) => ({
          field: filtersDescriptions[key].label,
          value: filtersDescriptions[key].formatedValue(value),
        })),
      movement: cachedMovementData,
      searchPeriod: period,
      total: {
        amount: 0,
        balance: 0,
        originalAmount: 0,
        debit: 0,
        debitPerCent: 0,
        credit: 0,
        creditPerCent: 0,
        increase: 0,
        discount: 0,
      },
    };
    const res = await printReceivableAccountsPDF(pdfBody);
    setPrintLoading(false);
    if (res?.status !== 200) {
      return notify("Falha ao imprimir relatório", true, "error");
    }

    const blob = b64toBlob(res?.data?.fileBase64, "application/pdf");
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={cachedMovementData}
          filename={`contas-receber-${Date.now()}`}
        />{" "}
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularLoader /> : <Print />}
          color="primary"
          disabled={printLoading || !cachedMovementData.length}
          onClick={handlePrintPDF}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
    </Grid>
  );
};
